export default defineI18nLocale(async (locale) => {
  const { fetchLocalizeJson } = useLocalize(locale);

  const [apiLocalizeData] = await Promise.all([
    fetchLocalizeJson(),
  ]);

  return {
    ...apiLocalizeData,
  };
});
